<template>
  <div class="row mt-5">
    <div class="col-12">
      <fb-paginacion
        :total="pages"
        :max="maxPages"
        v-model="page"
      />
    </div>
  </div>
</template>
<script>

import FbPaginacion from '@/febos/chile/_vue/componentes/FbPaginacion';

export default {
  components: { FbPaginacion },
  data() {
    return {
      page: this.value
    };
  },
  computed: {
  },
  watch: {
    value(newValue) {
      this.page = newValue;
    },
    page(newValue) {
      this.$emit('input', newValue);
    }
  },
  props: {
    value: { type: Number, required: false, default: 1 },
    pages: { type: Number, required: false, default: 1 },
    maxPages: { type: Number, required: false, default: 10 },
  }
};

</script>
